<template>
  <div class="home-ranking-box" style="margin-bottom: 10px;border-bottom: none !important;">
    <div class="title" style="border-bottom: none !important;display: none;">
      {{ $t("home.ranktitle") }}
    </div>
    <div>
      <van-row>
        <van-col :span="8">
          <div class="table-head">{{ $t("home.name") }}</div>
        </van-col>
        <van-col :span="10" style="text-align: right;padding-right: 10px;">
          <div class="table-head">{{ $t("home.price") }}</div>
        </van-col>
        <van-col :span="6">
          <div class="table-head txt-right">{{ $t("home.risefall") }}</div>
        </van-col>
      </van-row>
      <div v-if="safeData && safeData.length > 0">
      <van-row class="table-data-row" style="border-bottom: none;" v-for="(item,index) in safeData" :key="index" @click="toPage(item)">
        <van-col :span="8">
          <div class="table-name">
            <div class="icon" style="width: 16px;height: 16px;">
              <img :src="item.logo" />
            </div>
            <div class="name" style="line-height: 1;">{{ item.title.split('/')[0] }}<p style="color: rgba(106, 135, 157, 0.6);font-size: 14px;">{{ item.title.split('/')[1] }}</p></div>
          </div>
        </van-col>
        <van-col :span="10" style="text-align: right;padding-right: 10px;">
          <div class="table-price" style="line-height: 1;">{{ item.close }}
            <p style="color: rgba(106, 135, 157, 0.6);font-size: 14px;">
              {{ (parseFloat(item.vol) / 1000).toFixed(2) }} K
            </p>
          </div>
        </van-col>
        <van-col :span="6">
          <div class="table-rise-fall" :class="item.change.indexOf('+') != -1 ? 'rise':'fall'">{{ item.change }}%</div>
        </van-col>
      </van-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeRanking",
  props: ['datalst'],
  computed:{
    safeData(){
      return this.datalst || []
    }
  },
  methods:{
    toPage(item){
      this.$router.push(
        {
          name: "options",
          query: {
            currentSymbol: item.symbol,
            name:item.title,
          },
        },
        () => {}
      );
    },
  }
};
</script>

<style>
</style>
